// Created by hejikun on 2017/11/2 0002.
let guidance = [
  {
    path: '/guidance_illness_detail',
    name: '病症详情',
    component: () => import('@/pages/guidance/guidance_illness_detail')
  },
  {
    path: '/guidance_ABCList',
    name: '病症列表',
    component: () => import('@/pages/guidance/guidance_ABCList')
  },
  {
    path: '/guidance_hosList',
    name: '医院导诊',
    component: () => import('@/pages/guidance/guidance_hosList')
  },
  {
    path: '/guidance_fast',
    name: '快速导诊',
    component: () => import('@/pages/guidance/guidance_fast')
  },
  {
    path: '/guidance_diseaseList',
    name: '疾病导诊',
    component: () => import('@/pages/guidance/guidance_diseaseList')
  },
  {
    path: '/guidance_fast_all',
    name: '推荐医生',
    component: () => import('@/pages/guidance/guidance_fast_all')
  },
  {
    path: '/guidance_index',
    name: '智能导诊',
    component: () => import('@/pages/guidance/guidance_index')
  },
  {
    path: '/guidance_recommend',
    name: '智能推荐',
    component: () => import('@/pages/guidance/guidance_recommend')
  }
]

export default guidance
